import LoadingSkeleton from 'components/LoadingSkeleton';

const ClinicCardSkeleton = () => {
  return (
    <div className="flex gap-ds-2xl rounded-xl border border-color-border-card-lightmode bg-color-bg-lightmode-primary p-ds-2xl dark:border-color-border-card-darkmode dark:bg-color-bg-darkmode-primary max-sm:flex-col max-sm:gap-ds-xl max-sm:p-ds-xl">
      {/* Left Section */}
      <div className="flex flex-1 flex-col">
        <LoadingSkeleton width={120} height={16} />
        <LoadingSkeleton width={200} height={32} className="mt-4" />
        <div className="mt-2 flex items-center justify-between">
          <div className="inline-flex gap-1">
            <LoadingSkeleton width={150} height={16} />
          </div>
          <div className="inline-flex gap-1">
            <LoadingSkeleton width={100} height={16} />
          </div>
        </div>
        <div className="mt-12">
          <div className="mt-4 flex gap-8">
            <LoadingSkeleton circle={true} height={32} width={32} />
            <LoadingSkeleton circle={true} height={32} width={32} />
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-[0.5px]" />

      {/* Right Section */}
      <div className="flex shrink-0 flex-col items-center justify-between max-sm:gap-6">
        <div className="flex gap-4">
          <LoadingSkeleton width={80} height={16} />
          <LoadingSkeleton width={80} height={16} />
        </div>
        <div className="flex flex-col gap-ds-lg max-sm:flex-row">
          <LoadingSkeleton width={120} height={36} />
          <LoadingSkeleton width={120} height={36} />
        </div>
      </div>
    </div>
  );
};

export default ClinicCardSkeleton;
